import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  IntegerField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * User Role Link Schema - Junction table for many-to-many relationship
 *
 * Links users to roles in a many-to-many relationship.
 * This is a pure junction table - no repository needed, only schema for table creation.
 */

// Define user-role link fields
const UserRoleLnkFields = {
  user_id: IntegerField({
    title: 'ID пользователя',
    description: 'Внешний ключ к таблице identity_users',
  }),
  role_id: IntegerField({
    title: 'ID роли',
    description: 'Внешний ключ к таблице identity_roles',
  }),
};

// Complete schema with system fields
export const UserRoleLnkSchema = Type.Object({
  ...SystemFields,
  ...UserRoleLnkFields,
});

// Export types
export type UserRoleLnk = Static<typeof UserRoleLnkSchema>;

export default defineSchema({
  moduleName,
  tableName: 'user_roles_lnk',
  schema: UserRoleLnkSchema,

  // Foreign key constraints
  foreignKeys: [
    {
      column: 'user_id',
      references: { table: 'identity_users', column: 'id' },
      onDelete: 'CASCADE',
    },
    {
      column: 'role_id',
      references: { table: 'identity_roles', column: 'id' },
      onDelete: 'CASCADE',
    },
  ],

  // Indexes for performance
  additionalIndexes: ['user_id', 'role_id'],
  dependencies: ['identity_users', 'identity_roles'],
});
